<template>
    <div class="relative h-full flex flex-col justify-between">
        <section
            class="order-2 md:order-1 h-full w-full max-w-screen-3xl pt-10 flex-grow flex flex-col justify-between md:flex-row"
        >
            <div class="relative w-full flex-grow md:h-full md:w-1/2">
                <product-renderer
                    v-if="isMobile"
                    class="absolute"
                />
            </div>

            <div
                id="cz3ReviewWrapper"
                class="md:mt-8 xl:mx-24 md:pl-6 md:w-1/2 md:flex-grow flex flex-col md:justify-between bg-cloud-dark"
            >
                <div
                    v-for="group in allGroups"
                    :key="group"
                    :class="[ group.name === 'Personalization' ? 'order-1 md:order-none' : 'order-2 md:order-none' ]"
                    class="mb-4 xl:mb-7 px-3.5 md:p-0 flex flex-col gap-2"
                >
                    <div
                        v-if="group.name !== 'Personalization'"
                        class="flex flex-col"
                    >
                        <base-select :group-data="group" />

                        <label
                            :id="group.name"
                            class="font-freizeit text-xxs sm:text-sm"
                        >
                            {{ group.name }}
                        </label>
                    </div>

                    <edit-signature-input
                        v-else
                        @profanityChange="checkForProfanity"
                        class="mt-3"
                    />
                </div>

                <div
                    :class="{ 'order-2 w-full bg-cloud-dark': isMobile }"
                    class="flex flex-row h-[72px]"
                >
                    <quantity-controls
                        @quantityChange="updateQuantity"
                        class="w-1/4 xs:w-1/3 lg:w-1/4"
                    />

                    <base-button
                        @click="addToCart"
                        :is-disabled="blockCheckout"
                        :is-loading="isLoading"
                        variant="shine"
                        size="large"
                        class="grow !h-full"
                    >
                        <span class="w-full px-4 flex justify-between items-center">
                            <span class="flex">
                                {{ $t('CHECKOUT') }}

                                <img
                                    src="../assets/icons/arrow.svg"
                                    alt=""
                                    width="40"
                                    height="15"
                                    class="ml-2 lg:ml-3"
                                >
                            </span>

                            ${{ total }}
                        </span>
                    </base-button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButton from './BaseButton.vue';
    import BaseSelect from './BaseSelect.vue';
    import QuantityControls from './QuantityControls.vue';
    import EditSignatureInput from './EditSignatureInput.vue';
    import ProductRenderer from './ProductRenderer.vue';

    export default {
        mixins: [allStores],

        data() {
            return {
                quantity: 1,
                hasProfanity: false,
                isLoading: false,
            };
        },

        components: {
            BaseButton,
            BaseSelect,
            QuantityControls,
            EditSignatureInput,
            ProductRenderer,
        },

        computed: {
            allGroups() {
                // eslint-disable-next-line max-len
                return this.customizerStore.viewController?.blueprint.groups.filter((group) => group.custom['oe-is-step'] === 'true' && group.code !== 'Proof');
            },

            selectedOptions() {
                return this.customizerStore.viewController?.state.filter((x) => !this.isPlaceholder(x) && !this.isPersonalization(x));
            },

            bottlePrice() {
                return this.customizerStore.statePrice;
            },

            total() {
                return (this.bottlePrice * this.quantity).toFixed(0);
            },

            isMobile() {
                return this.appStore.isMobile;
            },

            blockCheckout() {
                return this.hasProfanity || this.customizerStore.personalizationTimer !== null;
            },
        },

        mounted() {
            if (this.isMobile) {
                /*
                    Resize events are ignored while the virtual keyboard is open.
                    Manually trigger resize event keyboard.
                */
                window.dispatchEvent(new Event('resize'));
            }
        },

        methods: {
            updateQuantity(quantity) {
                this.quantity = quantity;
            },

            addToCart() {
                this.isLoading = true;

                this.customizerStore.saveRecipe({
                    quantity: this.quantity,
                });
            },

            isPlaceholder(item) {
                return item.component.placeholder;
            },

            isPersonalization(item) {
                return item.placement.custom['widget-type'] === 'personalization';
            },

            checkForProfanity(hasProfanity) {
                this.hasProfanity = hasProfanity;
            },
        },
    };
</script>
